import { onBeforeMount } from 'vue'

import type { PortalAdTargeting } from '@/modules/adv/types'
import { useAdsStore } from '@/store/ads-store'

export const useSetAdTargetingOnMount = (targeting: PortalAdTargeting | undefined) => {
    const adsStore = useAdsStore()

    // eslint-disable-next-line no-restricted-syntax
    onBeforeMount(() => {
        if (targeting) {
            adsStore.updateTargeting(targeting)
        }
    })
}
